export default __webpack_public_path__ + "static/media/choice.e741a951.svg";